import {
  DrawerTooltipContainer,
  type DrawerTooltipContainerRef,
} from 'src/v2/commonComponents/DrawerTooltipContainer';
import { MoreMessageActionsToggle } from '../MoreMessageActionsToggle';
import { useRef } from 'react';
import { useComparingConversationsParams, useUniqueId } from 'src/hooks';
import { RelatedQuestionsButton } from '../RelatedQuestionsButton';
import { DeleteMessageButton } from '../DeleteMessageButton';
import { Message } from 'src/types';
import { TextDivider } from 'src/v2/commonComponents/TextDivider';
import styles from './MoreMessageActionsTool.module.scss';
import { useChatHistory } from 'src/hooks';

interface MoreMessageActionsToolProps {
  message: Message;
  disabled?: boolean;
}

export const MoreMessageActionsTool = ({
  message,
  disabled = false,
}: MoreMessageActionsToolProps) => {
  const { isNinjaRetired } = useChatHistory();
  const drawerRef = useRef<DrawerTooltipContainerRef>(null);
  const { uniqueId } = useUniqueId();
  const { isCompareMode } = useComparingConversationsParams();

  const tooltipAnchorId = `more-message-actions-${uniqueId}-tooltip`;

  const handleTooltipClose = () => {
    drawerRef.current?.onVisibilityToggle();
  };

  if (isNinjaRetired) {
    return null;
  }

  return (
    <DrawerTooltipContainer
      ref={drawerRef}
      id={tooltipAnchorId}
      place="top-start"
      offset={8}
      ToggleButton={MoreMessageActionsToggle}
      disabledToggle={disabled}
    >
      <div className={styles.root}>
        <RelatedQuestionsButton
          withTitle
          messageId={message.message_id}
          payload={message.payload}
          onClick={handleTooltipClose}
        />

        {!isCompareMode && <TextDivider withMargin={false} />}

        <DeleteMessageButton
          message={message}
          withTitle
          disabled={disabled}
          onClick={handleTooltipClose}
        />
      </div>
    </DrawerTooltipContainer>
  );
};
